import React, { useState } from 'react';
import PropTypes from 'prop-types';

const TimePreferenceStep = ({ preferences, onSubmit, onBack, submitting, currentStep, totalSteps }) => {
  const [localPreferences, setLocalPreferences] = useState(preferences);

  const handleChange = (e) => {
    const { name, checked } = e.target;
    setLocalPreferences(prev => ({
      ...prev,
      [name]: checked
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(localPreferences);
  };

  return (
    <div>
      <form onSubmit={handleSubmit}>
        <h2 className="text-2xl font-bold mb-4">Preferenze Orarie</h2>
        <p className="mb-4">Seleziona le fasce orarie in cui preferisci svolgere le tue sessioni</p>
        
        <div className="space-y-3 mb-6">
          <label className="flex items-center space-x-2">
            <input
              type="checkbox"
              name="morning"
              checked={localPreferences.morning}
              onChange={handleChange}
              className="h-5 w-5 rounded border-gray-300 text-orange-500 focus:ring-orange-500"
            />
            <span>Mattina (09:00 - 13:00)</span>
          </label>
          
          <label className="flex items-center space-x-2">
            <input
              type="checkbox"
              name="afternoon"
              checked={localPreferences.afternoon}
              onChange={handleChange}
              className="h-5 w-5 rounded border-gray-300 text-orange-500 focus:ring-orange-500"
            />
            <span>Pomeriggio (14:00 - 18:00)</span>
          </label>
          
          <label className="flex items-center space-x-2">
            <input
              type="checkbox"
              name="evening"
              checked={localPreferences.evening}
              onChange={handleChange}
              className="h-5 w-5 rounded border-gray-300 text-orange-500 focus:ring-orange-500"
            />
            <span>Sera (19:00 - 21:00)</span>
          </label>
          
          <label className="flex items-center space-x-2">
            <input
              type="checkbox"
              name="flexible"
              checked={localPreferences.flexible}
              onChange={handleChange}
              className="h-5 w-5 rounded border-gray-300 text-orange-500 focus:ring-orange-500"
            />
            <span>Flessibile (qualsiasi orario)</span>
          </label>
        </div>
        
        <button
          type="submit"
          disabled={submitting}
          className="w-full bg-orange-500 text-white py-3 rounded-md hover:bg-orange-600 mb-6"
        >
          {submitting ? 'Invio in corso...' : 'Completa Questionario'}
        </button>
      </form>
      
      <div className="w-full p-4 mt-4 bg-white">
        <div className="flex justify-between mx-auto w-full">
          <button
            onClick={onBack}
            className="px-4 py-2 rounded-full border font-semibold transition duration-150 ease-in-out bg-white text-orange-500 border-orange-500 hover:bg-orange-100"
          >
            Indietro
          </button>
          <div className="text-gray-500">
            Step {currentStep + 1} di {totalSteps}
          </div>
        </div>
      </div>
    </div>
  );
};

TimePreferenceStep.propTypes = {
  preferences: PropTypes.shape({
    morning: PropTypes.bool,
    afternoon: PropTypes.bool,
    evening: PropTypes.bool,
    flexible: PropTypes.bool
  }).isRequired,
  onSubmit: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
  currentStep: PropTypes.number.isRequired,
  totalSteps: PropTypes.number.isRequired
};

export default TimePreferenceStep;